<template>
    <div class="form-group">
        <label>{{ __('general.branch') }}</label>
        <treeselect :required="required !== undefined ? required : true"
                    v-model="value"
                    :placeholder="__('actions.select_branch')"
                    :multiple="true"
                    :disable-branch-nodes="true"
                    :options="options"
                    :normalizer="normalizer"
                    :noResultsText="__('store.no_results_found')"
                    @select="(node, id) => $emit('local_business_types', node)"
                    :limitText="count => `${__('general.and')} ${count} ${__('general.more')}`" auto-load-root-options/>

        <div id="treeselect" v-for="(val, i) in value">
            <input class="form-control" ref="hiddenInput" type="hidden" :name="`yellow_business_types[${i}]`" :value="val" :key="i">
        </div>
        <input v-if="!value.length" class="form-control" type="hidden" name="no type" :value="null">
    </div>
</template>

<script>
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

export default {
    name: 'LocalBusinessTypeSelection',

    components: {Treeselect},

    props: {
        old: Object,
        required: Boolean,
        preselected: {
            type: Array,
            default: () => [],
        },
    },

    data() {
        return {
            // define the default value
            value: this.preselected,
            // define options
            options: [],
            normalizer(node) {
                return {
                    id: node.id,
                    label: node.name,
                    children: node.children,
                }
            },
        }
    },

    mounted() {
        axios.get(this.$route('ajax.business-types')).then(response => {
            this.options = response.data
            if (this.old) {
                this.value = this.old.yellow_business_types
            }
        })
    },
}
</script>
